import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import Slide from "@mui/material/Slide";
import { URL, colors } from "../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../data/reducer/appState.reducer";
import { useNavigate } from "react-router-dom";
import { getLanguage } from "../../data/selector/language.selector";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Dialogue({ open, setOpen, Alert, navigate }) {
  const dispatch = useDispatch();
  const logout = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };
  const Language = useSelector(getLanguage);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: "bold", mt: 4 }}
            id="alert-dialog-slide-description"
          >
            {Alert}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          {Alert === Language?.AlertMsg.logout ? (
            <>
              <Button
                sx={{
                  width: 100,
                  margin: 1,
                  p: 1,
                  fontSize: 15,
                  backgroundColor: colors.blue,
                  border: "none",
                  "&:hover": {
                    backgroundColor: colors.blue,
                  },
                }}
                variant="contained"
                onClick={() => {
                  setOpen(false);
                  dispatch(setToken(""));
                  logout(URL.login);
                }}
              >
                Yes
              </Button>
              <Button
                sx={{
                  width: 100,
                  margin: 1,
                  p: 1,
                  fontSize: 15,
                  backgroundColor: colors.blue,
                  border: "none",
                  "&:hover": {
                    backgroundColor: colors.blue,
                  },
                }}
                variant="contained"
                onClick={handleClose}
              >
                No
              </Button>
            </>
          ) : (
            <Button
              sx={{
                width: 100,
                margin: 1,
                p: 1,
                fontSize: 15,
                backgroundColor: colors.blue,
                border: "none",
                "&:hover": {
                  backgroundColor: colors.blue,
                },
              }}
              variant="contained"
              onClick={() => {
                handleClose();
                if (navigate) {
                  dispatch(navigate);
                }
              }}
            >
              OK
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
